module.exports = __webpack_public_path__ + "static/room1-1-9b96e0f5f5ab82c726896c239cd0669d.jpg";